<script setup lang="ts">
import { computed, ref } from 'vue'
import { IconCalendar } from '../Icons'
import { toLocalInput } from '../../lib/format'
import { cx } from './cx'

const props = defineProps<{
  modelValue: string
  class?: string
}>()

const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const inputRef = ref<HTMLInputElement | null>(null)

const shown = computed(() => (props.modelValue ? props.modelValue.replace('T', ' ') : '选择到期时间'))
const minValue = computed(() => toLocalInput(new Date().toISOString()))

function openPicker() {
  const el = inputRef.value
  if (!el) return
  if (typeof el.showPicker === 'function') {
    try {
      el.showPicker()
      return
    } catch {
      el.focus()
      return
    }
  }
  el.focus()
}

function onInput(e: Event) {
  emit('update:modelValue', (e.target as HTMLInputElement).value)
}
</script>

<template>
  <div :class="cx('relative w-full min-w-[220px]', props.class)">
    <button
      type="button"
      class="field relative z-10 flex h-10 w-full items-center justify-between gap-3 text-left"
      @click="openPicker"
    >
      <span :class="modelValue ? 'text-[14px] text-text' : 'text-[14px] text-dim'">{{ shown }}</span>
      <IconCalendar :size="16" class="shrink-0 text-muted" />
    </button>
    <input
      ref="inputRef"
      type="datetime-local"
      tabindex="-1"
      aria-hidden="true"
      class="absolute inset-0 opacity-0"
      :min="minValue"
      :value="modelValue"
      @input="onInput"
    />
  </div>
</template>
